import SEO from "../components/SEO.jsx";
import Footer from "../components/layout/footer.jsx";

export function Blog() {
    return (
        <>
            <SEO title="Blog - PostMgr" description="Social media marketing tips, AI insights, and platform updates" url="https://postmgr.com/blog" />
            <div className="min-h-screen bg-gray-50 flex items-center justify-center">
                <div className="text-center">
                    <h1 className="text-4xl font-bold text-gray-900 mb-4">Blog</h1>
                    <p className="text-xl text-gray-600">Coming soon...</p>
                </div>
            </div>
            <Footer/>
        </>
    );
}

export default Blog;